var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { perRestaurant } from "../../di";
import { makeAutoObservable } from "mobx";
import { PurchaseOrderPayload } from "../PurchaseOrderPayload";
import { PackagingFeeInstanceFactory } from "../ExtraFee";
let ExtraFeeService = class ExtraFeeService {
    constructor(purchaseOrderPayload, packagingFeeInstanceFactory) {
        this.purchaseOrderPayload = purchaseOrderPayload;
        this.packagingFeeInstanceFactory = packagingFeeInstanceFactory;
        makeAutoObservable(this);
    }
    get extraFees() {
        return this.purchaseOrderPayload.orderLines.flatMap((orderLine, orderLineIndex) => this.packagingFeeInstanceFactory.create({ orderLineIndex, orderLine }));
    }
    get checkoutData() {
        return this.extraFees.map((extraFeeInstance) => extraFeeInstance.checkoutData).raw;
    }
};
ExtraFeeService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof PurchaseOrderPayload !== "undefined" && PurchaseOrderPayload) === "function" ? _a : Object, typeof (_b = typeof PackagingFeeInstanceFactory !== "undefined" && PackagingFeeInstanceFactory) === "function" ? _b : Object])
], ExtraFeeService);
export { ExtraFeeService };
